import { useTheme } from '@mui/material';

export const FewSpacesIcon = () => {
    const theme = useTheme();
    const { stroke } = theme.colors.other.icon;

    return (
        <svg width={49} height={48} fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.625 8C18.175 8 18.625 8.45 18.625 9V12H30.625V9C30.625 8.45 31.075 8 31.625 8C32.175 8 32.625 8.45 32.625 9V12H34.625C36.8312 12 38.625 13.7937 38.625 16V18V20V36C38.625 38.2062 36.8312 40 34.625 40H14.625C12.4188 40 10.625 38.2062 10.625 36V20V18V16C10.625 13.7937 12.4188 12 14.625 12H16.625V9C16.625 8.45 17.075 8 17.625 8ZM36.625 20H12.625V36C12.625 37.1063 13.5187 38 14.625 38H34.625C35.7313 38 36.625 37.1063 36.625 36V20ZM34.625 14H14.625C13.5187 14 12.625 14.8938 12.625 16V18H36.625V16C36.625 14.8938 35.7313 14 34.625 14ZM16.625 31C16.625 30.45 17.075 30 17.625 30H25.625C26.175 30 26.625 30.45 26.625 31C26.625 31.55 26.175 32 25.625 32H17.625C17.075 32 16.625 31.55 16.625 31ZM17.625 24H31.625C32.175 24 32.625 24.45 32.625 25C32.625 25.55 32.175 26 31.625 26H17.625C17.075 26 16.625 25.55 16.625 25C16.625 24.45 17.075 24 17.625 24Z"
                fill={stroke.primary}
            />
        </svg>
    );
};
